<div class="evaluation-field-label__label">
  {{ title() }}
  @if (required()) {
    <span
      class="evaluation-field-label__asterisk"
      [class.evaluation-field-label__asterisk--hidden]="filled()"
      >*</span
    >
  }
</div>

@if (hint()) {
  <div class="evaluation-field-label__hint">{{ hint() }}</div>
}
